import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
import { getUserInfo } from '@/services/authService';
import { getLicenseExpiredSoonPrompt } from '@/services/licenseService';

const initialState = {
  loading: false,
  info: {},
  perms: [],
  roles: [],
  licenseInfo: {},
};

export const getUserInfoAsync = createAsyncThunk('auth/getUserInfoAsync', async (params = {}) => {
  const { sortKey, sortType, ...others } = params;
  const response = await getUserInfo(others);
  if (isEmpty(response.data.perms)) {
    alert('未授权任何权限，请先授权后登录！');
    location.href = '/login';
  }
  return response.data;
});

export const getLicenseExpiredSoonPromptAsync = createAsyncThunk(
  'auth/getLicenseExpiredSoonPromptAsync',
  async () => {
    const response = await getLicenseExpiredSoonPrompt();
    return response.data;
  },
);

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    saveToken: (state, action) => {
      state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserInfoAsync.fulfilled, (state, action) => {
      const { info, permissionAll, roles, perms, thirdParty } = action.payload;
      state.info = info;
      state.permissionAll = permissionAll;
      state.roles = roles;
      state.perms = perms;
      state.thirdParty = thirdParty;
    });
    builder.addCase(getLicenseExpiredSoonPromptAsync.fulfilled, (state, action) => {
      state.licenseInfo = action.payload;
    });
  },
});

export const { saveToken } = authSlice.actions;
export default authSlice.reducer;
